import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';
import Logo from '../../assets/logo-white-2.png';
import {begin} from '../../utils/beforeunload';
import Introduksjon from '../../components/Introduksjon';
import Orddiktat from '../../components/Orddiktat';
import Ordkjedetesten from '../../components/Ordkjedetesten';
import Tulleordtesten from '../../components/Tulleordtesten';
import Skrivehastighet from '../../components/Skrivehastighet';
import Leseproven from '../../components/Leseproven';
import Ordforstaelse from '../../components/Ordforstaelse';
import SprakForstaelse from '../../components/SprakForstaelse';
import Ferdig from '../../components/Ferdig';
import ProgressBar from '../../components/ProgressBar';
import getTestInfo from '../../api/getTestInfo';
import getUserInfo from '../../api/getUserInfo';
import {unlockAudioNow} from '../../utils/unlockAudio';
import {isTablet} from 'react-device-detect';
import getUserGrade from '../../api/getUserGrade';
import setAnamneseVersion from '../../api/setAnamneseVersion';
import {setTestCandidateGrade} from '../../actions/index';
import strings from '../../utils/strings';

const STEP_MAP = {
	intro: {
		id: 'intro',
		label: 'Introduksjon',
		component: Introduksjon,
		trackProgress: false,
	},
	1: {
		id: 'orddiktat',
		label: strings.orddiktat,
		component: Orddiktat,
		trackProgress: true,
	},
	2: {
		id: 'ordkjedetesten',
		label: strings.ordkjedetesten,
		component: Ordkjedetesten,
		trackProgress: true,
	},
	3: {
		id: 'tulleordtesten',
		label: strings.tulleordtesten,
		component: Tulleordtesten,
		trackProgress: true,
	},
	4: {
		id: 'skrivehastighet',
		label: strings.Skrivehastighet,
		component: Skrivehastighet,
		trackProgress: true,
	},
	5: {
		id: 'leseproven',
		label: strings.leseproven,
		component: Leseproven,
		trackProgress: true,
	},
	6: {
		id: 'ordforstaelse',
		label: strings.ordforstaelse,
		component: Ordforstaelse,
		trackProgress: true,
	},
	7: {
		id: 'sprakforstaelse',
		label: strings.sprakForstaelse,
		component: SprakForstaelse,
		trackProgress: true,
	},
	ferdig: {
		id: 'ferdig',
		label: 'Fertig',
		component: Ferdig,
		trackProgress: false,
	},
};

const FULL_STEPS_WITH_INTRO = [
	STEP_MAP.intro,
	STEP_MAP[1],
	STEP_MAP[2],
	STEP_MAP[3],
	STEP_MAP[4],
	STEP_MAP[5],
	STEP_MAP[6],
	STEP_MAP[7],
	STEP_MAP.ferdig,
];

const FULL_STEPS_NO_INTRO = [
	STEP_MAP[1],
	STEP_MAP[2],
	STEP_MAP[3],
	STEP_MAP[4],
	STEP_MAP[5],
	STEP_MAP[6],
	STEP_MAP[7],
	STEP_MAP.ferdig,
];

class ScreeningTest extends React.Component {
	constructor() {
		super();

		this.state = {
			isLoggedIn: false,
			includeAnamnese: false,
			activeSteps: [],
			audioReady: !isTablet,
			gateLeaving: false,
		};

		this.buildActiveSteps = this.buildActiveSteps.bind(this);
	}

	buildActiveSteps(results) {
		const exclusiveTests = results && results.exclusiveTests
			? Object.values(results.exclusiveTests)
			: [];
		const grade = results ? results.grade : null;

		if (exclusiveTests.length) {
			const remainingSteps = exclusiveTests
				.map((testNumber) => STEP_MAP[testNumber])
				.filter(Boolean);

			return [...remainingSteps, STEP_MAP.ferdig];
		}

		if (grade) {
			return FULL_STEPS_NO_INTRO;
		}

		return FULL_STEPS_WITH_INTRO;
	}

	componentDidMount() {
		getTestInfo().then((results) => {
			const activeSteps = this.buildActiveSteps(results);
			const exclusiveTests = results && results.exclusiveTests
				? Object.values(results.exclusiveTests)
				: [];
			const grade = results ? results.grade : null;

			this.setState({activeSteps: activeSteps});

			if (exclusiveTests.length) {
				getUserGrade().then((userGrade) => {
					this.props.onSetTestCandidateGrade(userGrade);
				});
			} else if (grade) {
				this.props.onSetTestCandidateGrade(grade);
			}

			/* setAnamneseVersion().then((response) => {
				this.setState({
					includeAnamnese: response === 'True',
				});
			}); */

			getUserInfo().then((response) => {
				if (response.ok) {
					this.setState({
						isLoggedIn: true,
					});
					begin();
				} else {
					window.location.href = '/';
				}
			});
		});
	}

	renderGate(leaving) {
		return (
			<div className={`audio-gate${leaving ? ' is-leaving' : ''}`}>
				<div className="audio-gate__content">
					<img
						className="audio-gate__logo"
						src={Logo}
						alt="Literate Logo"
					/>
					<h1 className="audio-gate__title">
						{strings.adulttest}
					</h1>
					<p className="audio-gate__description">
						{strings.dysmate_welcome_text}
					</p>
					<button
						className="audio-gate__btn lit-btn bg-primary"
						onClick={() => {
							unlockAudioNow();
							// Set audioReady immediately (same setState batch as gateLeaving)
							// so AudioPlayers mount within the iOS user-activation window.
							// The gate fades as a CSS overlay while the test renders behind it.
							this.setState({gateLeaving: true, audioReady: true});
							setTimeout(() => this.setState({gateLeaving: false}), 350);
						}}
					>
						{strings.start}
					</button>
				</div>
			</div>
		);
	}

	render() {
		const {isLoggedIn, includeAnamnese, activeSteps, audioReady, gateLeaving} = this.state;
		const {currentStepIndex} = this.props;

		// Gate-only state: not yet started
		if (!audioReady) {
			return this.renderGate(gateLeaving);
		}

		if (!isLoggedIn || !activeSteps.length) {
			// Still waiting for API data — keep gate visible while it's leaving
			return gateLeaving ? this.renderGate(true) : null;
		}

		const safeStepIndex =
			currentStepIndex >= 0 && currentStepIndex < activeSteps.length
				? currentStepIndex
				: 0;

		const currentStep = activeSteps[safeStepIndex];

		if (!currentStep) {
			return null;
		}

		const CurrentStep = currentStep.component;

		const progressSteps = activeSteps.filter((step) => step.trackProgress);
		const completedCount = activeSteps
			.slice(0, safeStepIndex + 1)
			.filter((step) => step.trackProgress).length;
		const totalCount = progressSteps.length;

		return (
	<>
		{gateLeaving && this.renderGate(true)}
		<div className="screening-test">
			<header className="lit-header screening-test__header">
				<div className="screening-test__header-inner">
					<h1 className="lit-logo">
						<img
							className="lit-logo__img"
							src={Logo}
							alt="literate-logo"
						/>
					</h1>

					{currentStep.trackProgress && (
						<div className="screening-test__progress-slot">
							<ProgressBar
								completedCount={completedCount}
								totalCount={totalCount}
								currentLabel={currentStep.label}
							/>
						</div>
					)}
				</div>
			</header>

			<div className="lit-wrapper--article text-center screening-test__content">
				<CurrentStep includeLongAnamnese={includeAnamnese} />
			</div>
		</div>
	</>
);
	}
}

const mapStateToProps = (state) => {
	const {currentStepIndex} = state;

	return {
		currentStepIndex,
	};
};
const mapDispatchToProps = {
	onSetTestCandidateGrade: setTestCandidateGrade,
};

export default connect(mapStateToProps, mapDispatchToProps)(ScreeningTest);
